import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferStack() {
  return <section id="pricing" className="py-14 sm:py-24 px-4 relative" data-id="element-79">
      <div className="max-w-4xl mx-auto" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-b from-brand-red/20 to-transparent border border-brand-red/30 rounded-2xl p-5 sm:p-12 text-center" data-id="element-81">
          <h2 className="text-2xl sm:text-4xl font-bold text-white mb-3 sm:mb-4" data-id="element-82">
            THE PRICE{' '}
            <span className="text-brand-gold" data-id="element-83">(TOTAL TRANSPARENCY)</span>
          </h2>

          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mb-5 sm:mb-8 leading-relaxed" data-id="element-84">
            No shipping costs. No wasted paper. Just pure, direct knowledge.
          </p>

          <div className="flex justify-center mb-3 sm:mb-4" data-id="element-85">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 text-brand-gold fill-brand-gold" data-id="element-86" />)}
          </div>

          <div className="mb-4 sm:mb-6" data-id="element-87">
            <span className="text-2xl text-gray-400 line-through font-oswald" data-id="element-88">
              TOTAL VALUE: $50+
            </span>
          </div>

          <p className="text-base sm:text-lg text-gray-300 mb-3 sm:mb-4 max-w-xl mx-auto" data-id="element-89">
            For the price of three coffees, you get the intellectual arsenal of
            one of the most influential activists of the 21st century.
          </p>

          <div className="mb-6 sm:mb-10" data-id="element-90">
            <span className="text-gray-300 text-xl uppercase tracking-widest block mb-2 font-oswald" data-id="element-91">
              YOUR PRICE TODAY
            </span>
            <span className="text-5xl sm:text-8xl font-bold text-brand-gold font-oswald drop-shadow-[0_0_15px_rgba(212,168,83,0.5)]" data-id="element-92">
              $17.00
            </span>
          </div>

          <CTAButton className="w-full sm:w-auto text-lg sm:text-2xl py-4 sm:py-5 px-6 sm:px-12" data-id="element-93">
            YES, I WANT THE EBOOK &amp; BONUSES — INSTANT ACCESS FOR $17
          </CTAButton>

          <p className="mt-4 sm:mt-6 text-gray-500 text-xs sm:text-sm font-oswald tracking-wider" data-id="element-94">
            We accept Credit Cards, Debit Cards &amp; PayPal. 100% Secure
            Processing.
          </p>
        </motion.div>
      </div>
    </section>;
}